import { Component } from 'react';

import { ATCGroup } from '@stratumn/atomic';

import gql from 'graphql-tag';
import pathToRegexp from 'path-to-regexp';
import PropTypes from 'prop-types';

import { history } from '@/components/root';
import { ROUTE_GROUP_BOARD } from '@/constant/routes'; // Kanban view removed (eslint disable comment on previous line can be removed if Kanban view is once again included in the application)
import { orderStages } from '@/utils/stage';
import StageBox, { fragments as stageBoxFragments } from '../stage';

export class GroupColumn extends Component {
  static propTypes = {
    group: PropTypes.object.isRequired
  };

  goToGroupBoard = () =>
    history.push(
      pathToRegexp.compile(ROUTE_GROUP_BOARD)({ id: this.props.group.rowId })
    );

  render = () => {
    const { group } = this.props;
    // if the group id starts with a '-', it comes from an optimistic response.
    const isGroupReady = !group.rowId.startsWith('-');

    const stages = orderStages(group.stages.nodes);

    return (
      <ATCGroup
        avatarSrc={group.avatar}
        header={group.name}
        headerOnClick={this.goToGroupBoard}
        key={group.rowId}
        loading={!isGroupReady}
      >
        {stages.map(stage => (
          <StageBox groupId={group.rowId} key={stage.rowId} stage={stage} />
        ))}
      </ATCGroup>
    );
  };
}

export const fragments = {
  group: gql`
    fragment GroupColumnFragment on Group {
      rowId
      name
      avatar
      stages {
        nodes {
          ...StageBoxFragment
        }
        totalCount
      }
    }
    ${stageBoxFragments.stage}
  `
};

export default GroupColumn;
